import { AppRoute } from 'app/app-layout/constants/index';
import { NavCategoryId } from 'app/app-layout/models/nav/nav-category-ids.enum';
import { NavItemPrimary } from 'app/app-layout/models/nav/nav-item-primary.model';
import { NavItemSecondary } from 'app/app-layout/models/nav/nav-item-secondary.model';
import { AppScopes } from 'app/core/authentication/models/scopes.enum';


export class HelpNavItem extends NavItemPrimary {
  constructor() {
    super({
      labelId: '$nav_primary_help',
      categoryId: NavCategoryId.HELP,
      categoryIcon: 'ico-nav-help.svg',
      route: AppRoute.help,
      menuItems: [
        new HelpSecondaryNavItem(),
      ],
    });
  }
}

export class HelpSecondaryNavItem extends NavItemSecondary {
  constructor() {
    super({
      labelId: '$nav_primary_help',
      scopes: [
        AppScopes.FULL_ACCESS,
        AppScopes.PERSONAL_DASHBOARD,
        AppScopes.DEFAULT_USER,
        AppScopes.EMPLOYEE_TRAINING_ACCESS,
        AppScopes.TRAINING_CONFIG,
        AppScopes.MYZONE_EQUIPMENT_PERMISSION,
      ],
      route: AppRoute.help,
      categoryId: NavCategoryId.HELP,
    });
  }
}
